import withLocalLoader from 'components/HOCs/withLocalLoader';
import { connect } from 'react-redux';
import { getFAQsData, getAppointmentsViewData } from 'state/actions/actions';
import { getCarrierFaqs } from 'state/actions/faqs';
import Resources from './Resources';

const mapStateToProps = ({ faqs, appointments, user }) => ({
  faqs: faqs.faqsArray,
  carriers: appointments.carriers,
  appointedCarriers: appointments.appointedCarriers,
  carrierFaqs: faqs.carrierFaqsArray,
  carrierLoader: faqs.carrierLoader,
  user: user.zohoData
});

export default connect(mapStateToProps, {
  getFAQsData,
  getAppointmentsViewData,
  getCarrierFaqs
})(withLocalLoader(Resources, true, 'Resources', 'Resources'));
